import {HttpClient} from '@angular/common/http';
import { Service, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Entity} from '../entity/entity';
import {Qewl} from '../model/qewl';
import {GoogleService} from './google-service';

@Service()
export class QewlService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase: string = environment.serviceUrl;

  getQewlById(entity: Entity): Observable<Qewl[]> {
    const url = this.urlBase + 'qewl/getLinesById/' + entity.id.entityId + '/' + entity.id.entityRevision;
    return this.http.get<Qewl[]>(url);
  }

  sendToQewl(qewl: Qewl): Observable<any> {
    const url = this.urlBase + 'qewl/sendLineToQewl/';
    return this.http.post(url, JSON.stringify(qewl), {headers: {'Content-Type': 'application/json'}, responseType: 'text'});
  }

  removeFromQewl(qewl: Qewl): Observable<any> {
    const url = this.urlBase + 'qewl/removeLineFromQewl/';
    return this.http.post(url, JSON.stringify(qewl), {headers: {'Content-Type': 'application/json'}, responseType: 'text'});
  }

  getMfgNumberExport(entity: Entity): Observable<Blob> {
    const url = this.urlBase + 'qewl/getMfgNumberExport/' + entity.id.entityId + '/' + entity.id.entityRevision;
    return this.http.get(url, {responseType: 'blob'})
  }
}
